import tvgConf from "@tvg/conf";

const { NODE_ENV = "production" } = process.env;
const isDev = NODE_ENV === "development";

const conf = tvgConf();

const { environment } = conf;

const getPublicPath = (publicPath?: string) =>
  (environment === "staging" || environment === "production") && !isDev
    ? `https://${conf.config("/")?.domain?.desktop}/static/hdr/assets/`
    : publicPath;

export default getPublicPath;
